import axiosInstance from "../../api/auth/axiosInstance";
const fetchPrintingData = async (aptId) => {
  try {
    const response = await axiosInstance.get(`/priscription-data/${aptId}`,{headers: { authType: "PostLogin" } });
    
    const data = response.data.data;

    // Map API response to the required structure
    const companyId = data?.companyId;
    const companyName = data?.companyName;
    const companyHeaderImage = data?.companyHeaderImage;
    const companyFooterImage = data?.companyFooterImage;
    const doctorId = data?.doctorId;
    const doctorName = data?.doctorName;
    const dateParts = data?.appointmentDateTime
  ? data.appointmentDateTime.split('T')[0].split('-')
  : ["", "", ""];
const date = dateParts[2] && dateParts[1] && dateParts[0]
  ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
  : "";// Extract date from appointmentDateTime
    const diagnosis = Array.isArray(data.diagnosis)
  ? data.diagnosis.map(item => item.diagnosisName)
  : [];

const tests = Array.isArray(data.tests)
  ? data.tests.map(item => item.testName)
  : [];

const procedures = Array.isArray(data.treatment)
  ? data.treatment.map(item => item.treatmentName)
  : [];

const medicines = Array.isArray(data.medicene)
  ? data.medicene.map(item => ({
      name: item.medicine,
      instructions: item.notes || ""
    }))
  : [];
    const remarks = data.advice ?? "";
    const patientName = data.patientName;
    const patientId = data.patientId;
    const age = data.age?.toString();
    const sex = data.sex;
    const phone = data.phone;
    const address = data.address;
    const weight = data.weight;
    const bp = data.bp;
    

const nextReviewDate = data?.nextVisitDate
  ? (() => {
      const dateParts = data.nextVisitDate.split("T")[0].split("-");
      return dateParts.length === 3
        ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
        : "";
    })()
  : "";

    return Promise.resolve({
      companyId,
      companyName,
      companyHeaderImage,
      companyFooterImage,
      doctorId,
      doctorName,
      date,
      diagnosis,
      tests,
      procedures,
      medicines,
      remarks,
      patientName,
      patientId,
      age,
      sex,
      phone,
      address,
      weight,
      bp,
      nextReviewDate,
    });
  } catch (error) {
    console.error('Error fetching prescription data:', error);
    return Promise.reject(error);
  }
};

export default fetchPrintingData;